"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
var CURRENCY_ENUM;
(function (CURRENCY_ENUM) {
    CURRENCY_ENUM["GOLD"] = "Celo Gold";
    CURRENCY_ENUM["DOLLAR"] = "Celo Dollar";
    CURRENCY_ENUM["EURO"] = "Celo Euro";
})(CURRENCY_ENUM = exports.CURRENCY_ENUM || (exports.CURRENCY_ENUM = {}));
exports.CURRENCIES = (_a = {},
    _a[CURRENCY_ENUM.GOLD] = {
        symbol: '',
        code: 'cGLD',
        displayDecimals: 3,
    },
    _a[CURRENCY_ENUM.DOLLAR] = {
        symbol: '$',
        code: 'cUSD',
        displayDecimals: 2,
    },
    _a[CURRENCY_ENUM.EURO] = {
        symbol: '€',
        code: 'cEUR',
        displayDecimals: 2,
    },
    _a);
exports.resolveCurrency = function (label) {
    if (label && label.toLowerCase().includes('dollar')) {
        return CURRENCY_ENUM.DOLLAR;
    }
    else if (label && label.toLowerCase().includes('euro')) {
        return CURRENCY_ENUM.EURO;
    }
    else if (label && label.toLowerCase().includes('gold')) {
        return CURRENCY_ENUM.GOLD;
    }
    else {
        console.info('Unable to resolve currency from label: ' + label);
        return CURRENCY_ENUM.DOLLAR;
    }
};
var SHORT_CURRENCIES;
(function (SHORT_CURRENCIES) {
    SHORT_CURRENCIES["DOLLAR"] = "dollar";
    SHORT_CURRENCIES["GOLD"] = "gold";
    SHORT_CURRENCIES["EURO"] = "euro";
})(SHORT_CURRENCIES = exports.SHORT_CURRENCIES || (exports.SHORT_CURRENCIES = {}));
exports.currencyToShortMap = (_b = {},
    _b[CURRENCY_ENUM.DOLLAR] = SHORT_CURRENCIES.DOLLAR,
    _b[CURRENCY_ENUM.GOLD] = SHORT_CURRENCIES.GOLD,
    _b[CURRENCY_ENUM.EURO] = SHORT_CURRENCIES.EURO,
    _b);
//# sourceMappingURL=currencies.js.map